import { createFileRoute } from '@tanstack/react-router';
import { PagesListPage } from '../../features/content';

export const Route = createFileRoute('/admin/content/')({ component: PagesListPage });
